import React from 'react';

function Header() {
  return (
    <header className="app-header">
      <div className="container header-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <a href="/" style={{ textDecoration: 'none' }}>
          <div className="logo-accent">Home<span className="logo">steadr</span></div>
        </a>
        <nav style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {/* Official App Store Badge */}
          <a
            href="#download-appstore"
            title="Download on the App Store"
            style={{ display: 'inline-flex', height: '38px', borderRadius: '7px', overflow: 'hidden', transition: 'transform 0.2s ease' }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135 40" style={{ height: '38px', width: 'auto' }}>
              <rect width="135" height="40" rx="7" fill="#000000"/>
              <path fill="#FFFFFF" d="M24.2 16.4c0-2.8 2.3-4.2 2.4-4.3-1.3-1.9-3.3-2.2-4-2.2-1.7-.2-3.3 1-4.2 1-.9 0-2.2-1-3.6-1-1.9 0-3.6 1.1-4.6 2.8-2 3.5-.5 8.7 1.4 11.5 1 1.4 2.1 2.9 3.6 2.8 1.5-.1 2.1-1 3.9-1s2.4 1 3.9 1c1.6 0 2.6-1.4 3.6-2.8 1.1-1.6 1.6-3.2 1.6-3.3-.1 0-3.9-1.5-3.9-5.5zM21.7 8.3c.8-1 1.3-2.3 1.1-3.7-1.1.1-2.5.8-3.3 1.7-.7.8-1.3 2.2-1.1 3.5 1.3.1 2.5-.5 3.3-1.5z"/>
              <text x="39" y="15" fill="#FFFFFF" fontSize="8" fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" fontWeight="400" letterSpacing="0.2">Download on the</text>
              <text x="39" y="27" fill="#FFFFFF" fontSize="13" fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" fontWeight="600" letterSpacing="0.2">App Store</text>
            </svg>
          </a>

          {/* Official Google Play Badge */}
          <a
            href="#download-googleplay"
            title="Get it on Google Play"
            style={{ display: 'inline-flex', height: '38px', borderRadius: '7px', overflow: 'hidden', transition: 'transform 0.2s ease' }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135 40" style={{ height: '38px', width: 'auto' }}>
              <rect width="135" height="40" rx="7" fill="#000000"/>
              <path fill="#4285F4" d="M12.8 11.1l7.8 8.9-7.8 8.9V11.1z"/>
              <path fill="#EA4335" d="M12.8 11.1l11.4 6.5-3.6 2.4-7.8-8.9z"/>
              <path fill="#FBBC04" d="M12.8 28.9l7.8-8.9 3.6 2.4-11.4 6.5z"/>
              <path fill="#34A853" d="M24.2 17.6l2.9 1.6c.7.4.7 1 0 1.4l-2.9 1.6-3.6-2.4 3.6-2.2z"/>
              <text x="36" y="15" fill="#FFFFFF" fontSize="7.5" fontFamily="Roboto, sans-serif" fontWeight="500" letterSpacing="0.5">GET IT ON</text>
              <text x="36" y="27" fill="#FFFFFF" fontSize="13" fontFamily="Roboto, sans-serif" fontWeight="700" letterSpacing="0.2">Google Play</text>
            </svg>
          </a>

          {/* Launch Web App Button */}
          <a
            href="https://app.homesteadr.ai"
            className="header-cta"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justify: 'center',
              height: '38px',
              backgroundColor: '#2D5A27',
              color: '#FFFFFF',
              borderRadius: '7px',
              padding: '0 16px',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              textDecoration: 'none',
              transition: 'background-color 0.2s ease, transform 0.2s ease',
              boxShadow: '0 2px 6px rgba(45,90,39,0.3)',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1E3E1B';
              e.currentTarget.style.transform = 'scale(1.03)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#2D5A27';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Launch Web App 🌱
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
